export default __webpack_public_path__ + "static/media/fad-timeselect.3b6faa08.svg";